/* Copyright Verge Technologies 2018
/* Copyright Verge Technologies 2018
 * @file applications.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for housing applications
 */

// Modules
import React from 'react';
import { Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import Hashids from 'hashids'
// GraphQL
import { APPLICATIONS_QUERY } from '../../graphql';

// Components
import ApplicationCard from '../../components/ApplicationCard/applicationCard';
const hashids = new Hashids();
const Applications = () => {
  return (
    <div className="applications-container">
      <Query query={APPLICATIONS_QUERY} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
              <div className="heading-container">
                <h1>Applications</h1>
                <hr />
              </div>
              <div className="application-container">
                <ul>
                  {JSON.parse(data.getApplications).map((application) => {
                    const shortIdArr = [];
                    shortIdArr.push(application.short_id);
                    if (application.children.length > 0) {
                      application.children.forEach(child => shortIdArr.push(child.short_id))
                    }
                    return (
                      <ApplicationCard
                        title={application.name}
                        backgroundImage={application.background_image}
                        iconImage={application.icon}
                        address={application.link}
                        key={application.id}
                        id={hashids.encode(shortIdArr)}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default withRouter(Applications);



// WEBPACK FOOTER //
// ./src/components/Applications/applications.js